function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _templateObject;
var _excluded = ["direction", "order", "isOpen", "maxWidth"],
  _excluded2 = ["children", "isOpen", "lightsOutOpacity", "onClose", "order", "renderActions", "uiTheme"],
  _excluded3 = ["direction", "closeIconOptions", "maxWidth", "responsive", "style"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import styled from 'styled-components';
import { get, merge } from 'lodash';
import LightsOut from '../LightsOut';
import { styledComponentsResponsiveStyles } from '../../utils/responsive';
import withTheme from '../Theme/withTheme';
import PanelActions from './PanelActions';
import PanelClose from './PanelClose';
import PanelManager from './PanelManager';
import panelPropsToCss from './props-to-css';
import zIndexCalculator from './z-index-calculator';
var PanelContainer = function PanelContainer(_ref) {
  var direction = _ref.direction,
    order = _ref.order,
    isOpen = _ref.isOpen,
    maxWidth = _ref.maxWidth,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("div", otherProps);
};
PanelContainer.defaultProps = {
  maxWidth: undefined
};
var StyledPanelContainer = styled(PanelContainer)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  background-color: #fff;\n  height: 100%;\n  position: fixed;\n  top: 0;\n  width: 100%;\n\n  ", "\n  ", "\n"])), function (props) {
  return panelPropsToCss(props);
}, function (props) {
  var responsive = props.responsive,
    uiTheme = props.uiTheme;
  return styledComponentsResponsiveStyles(uiTheme, responsive, function (breakpointProps) {
    return panelPropsToCss(_objectSpread({
      uiTheme: uiTheme
    }, breakpointProps));
  });
});
var componentDefaults = {
  maxWidth: 320,
  direction: 'right',
  closeIconOptions: {
    color: 'black'
  },
  responsive: [],
  style: {}
};
var Panel = /*#__PURE__*/function (_React$Component) {
  function Panel() {
    _classCallCheck(this, Panel);
    return _callSuper(this, Panel, arguments);
  }
  _inherits(Panel, _React$Component);
  return _createClass(Panel, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var isOpen = this.props.isOpen;

      // If the panel starts as open, tell PanelManager,
      // do not tell PanelManager if the Panel starts closed.
      if (isOpen) {
        PanelManager.registerAsOpen();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var prevIsOpen = prevProps.isOpen;
      var isOpen = this.props.isOpen;

      // When the panel opens or closes tell PanelManager
      if (isOpen !== prevIsOpen) {
        if (isOpen) {
          PanelManager.registerAsOpen();
        } else {
          PanelManager.registerAsClosed();
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      PanelManager.registerAsClosed();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        children = _this$props.children,
        isOpen = _this$props.isOpen,
        lightsOutOpacity = _this$props.lightsOutOpacity,
        onClose = _this$props.onClose,
        order = _this$props.order,
        renderActions = _this$props.renderActions,
        uiTheme = _this$props.uiTheme,
        otherProps = _objectWithoutProperties(_this$props, _excluded2);
      var themeDefaults = get(uiTheme, 'panel', {});
      var mergedProps = merge({}, componentDefaults, themeDefaults, _objectSpread({}, otherProps));
      var direction = mergedProps.direction,
        closeIconOptions = mergedProps.closeIconOptions,
        maxWidth = mergedProps.maxWidth,
        responsive = mergedProps.responsive,
        customStyle = mergedProps.style,
        otherMergedProps = _objectWithoutProperties(mergedProps, _excluded3);
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(StyledPanelContainer, _extends({
        isOpen: isOpen,
        style: customStyle,
        order: order,
        direction: direction,
        maxWidth: maxWidth
      }, otherMergedProps), /*#__PURE__*/React.createElement("div", {
        style: {
          position: 'relative',
          height: '100%',
          display: 'inline-block',
          width: '100%'
        }
      }, /*#__PURE__*/React.createElement(PanelClose, _extends({
        onClose: onClose
      }, closeIconOptions)), children, renderActions && /*#__PURE__*/React.createElement(PanelActions, null, renderActions()))), /*#__PURE__*/React.createElement(LightsOut, {
        onClick: onClose,
        isActive: isOpen,
        opacity: lightsOutOpacity,
        zIndex: zIndexCalculator('lightsout', order)
      }));
    }
  }]);
}(React.Component);
Panel.defaultProps = {
  closeIconOptions: {},
  direction: undefined,
  lightsOutOpacity: undefined,
  maxWidth: undefined,
  order: 1,
  renderActions: null,
  responsive: undefined,
  style: undefined,
  uiTheme: {}
};
Panel.displayName = 'Panel';
export default withTheme(Panel);